import { emptyArray } from '../../default-props/empty';

export const selectData = (state) => state ?? emptyArray;
